<template>
  <!-- 头部整体盒子 -->
  <footer class="gs18-Footer" role="contentinfo" data-js-gs18-footer>
    <div class="gs18-Footer__Links gs18-Footer__Links--withme">
      <ul class="gs18-Footer__Legal">
        <li><a href="/en/terms">Terms of Use</a></li>
        <li>
          <a href="/en/policy">Privacy Policy</a>
        </li>
      </ul>
      <small class="gs18-Footer__Copyright">© Mitsubishi Electric Shanghai Electric Elevator Co., Ltd. </small>
    </div>
    <!-- Please write ICP number -->
    <div class="gs18-Footer__ExtentionInner">
      <ul class="gs18-Footer__IcpNums">
        <li class="gs18-Footer__IcpNumsItem">
          <a href="http://beian.miit.gov.cn/" target="_blank">沪ICP备08000474号</a>
        </li>
        <li class="gs18-Footer__IcpNumsItem">
          <!-- <a href="http://www.beian.gov.cn/"></a> -->
          <img loading="lazy" src="@/assets/img/Gongan.png" alt="" />
          沪公网安备31011202002548号
        </li>
      </ul>
      <!-- /.gs18-Footer__ExtentionInner -->
    </div>
    <p class="gs18-GoTop"><a href="#" data-js-gs18-gotop></a></p>
  </footer>
</template>
<script>
export default {
  name: "Footer3",
  data() {
    return {};
  },
};
</script>
<style lang="less">
.gs18-Footer .gs18-HeadingLv2 {
  margin-top: 0;
}

.gs18-Footer__IcpNums {
  margin: 0;
  padding: 0;
}

.gs18-Footer__IcpNumsItem {
  margin: 0;
  padding: 0;
  display: inline-block;
  list-style: none;
}

.gs18-Footer__IcpNumsItem:not(:first-child) {
  margin-left: 10px;
}

.gs18-Footer__IcpNumsItem img {
  display: inline-block;
  margin: 0 5px 0 0;
  vertical-align: middle;
}

.footer-img {
  width: 200px;
}

.gs18-Footer__List>li:nth-child(odd) {
  margin-right: 20px;
}

.gs18-Footer__List {
  width: auto;
  margin-top: 35px;
}

.footer {
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: 980px) {
    display: block;
  }

  .tel {
    margin-top: 30px;

    span {
      font-size: 26px;
      font-weight: bold;

      @media only screen and (max-width: 980px) {
        font-size: 20px;
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer3.vue